import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteExpense = ({
    setIsDeleteExpense,
    selectedData,
    deleteExpenseLoading,
    deleteExpenseMutate,
    propId,
    filter,
    deleteRecurringExpenseMutate,
    deleteRecurringExpenseLoading
}) => {
    const handleDeleteSubmit = () => {
        if (filter === "RE") {
            deleteRecurringExpenseMutate({
                id: selectedData?.id,
            });
        } else {
            deleteExpenseMutate({
                expenseId: selectedData?.id,
                propId: propId
            });
        }
    };

    const isLoading = filter === "RE"
        ? deleteRecurringExpenseLoading
        : deleteExpenseLoading;

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteExpense}
            title="Confirm Deletion"
        >
            <WarningText>
                Are you sure you want to delete this expense?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteExpense(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={isLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {isLoading ? "Loading..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteExpense;